// @ts-check
import { forEach, times, constant } from "lodash";

const enableSupplyGrouping = (grouping, columnCount) => {
  if (!grouping?.isSupply) {
    return;
  }

  grouping.canHaveConstraints = true;
  grouping.canEditConstraints = true;
  if (!grouping.constraints?.length) {
    grouping.constraints = times(columnCount, constant(null));
  }
};

const enableSupplyGroupingForecastTargets = (groupings, columnCount) => {
  const visit = (grouping) => {
    enableSupplyGrouping(grouping, columnCount);
    forEach(grouping.childGroupings, visit);
  };

  forEach(groupings, visit);
};

export default enableSupplyGroupingForecastTargets;
